// extracted by mini-css-extract-plugin
export default {"buttonPair":"ButtonPair_buttonPair__jHuBY","primary":"ButtonPair_primary__GfOgx","secondary":"ButtonPair_secondary__om3br"};